import { z } from 'zod'

// Contact types allowed for domain registration
export const TLDContactType = z.enum(['PERSON', 'ORG', 'ROLE'])
export type TLDContactType = z.infer<typeof TLDContactType>

// TLD registration rules
export const TLDRules = z.object({
  tld: z.string(),
  owner_types: z.array(TLDContactType).optional(),
  admin_types: z.array(TLDContactType).optional(),
  local_owner: z.boolean().optional(),
  local_admin: z.boolean().optional(),
  min_length: z.number().int().optional(),
  max_length: z.number().int().optional(),
  idn: z.boolean().optional(),
  idn_chars: z.string().optional(),
  whois_protection: z.boolean().optional(),
  trustee: z.boolean().optional(),
  transfer_lock: z.boolean().optional(),
  privacy_level: z.string().optional(),
  company_needed: z.boolean().optional(),
  person_needed: z.boolean().optional(),
  auth_code: z.string().optional()
})

export type TLDRules = z.infer<typeof TLDRules>

// Response from /domain/rules endpoint (map of TLD -> rules)
export const TLDRulesResponse = z.record(z.string(), TLDRules)
export type TLDRulesResponse = z.infer<typeof TLDRulesResponse>
